import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {Analytics} from '@vercel/analytics/react';
import {SpeedInsights} from '@vercel/speed-insights/react';
import App from './App.tsx';
import GlobalDomTranslator from './components/GlobalDomTranslator.tsx';
import LanguageSwitcher from './components/LanguageSwitcher.tsx';
import { LanguageProvider } from './contexts/LanguageContext.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <GlobalDomTranslator />
      <App />
      <LanguageSwitcher />
      <Analytics />
      <SpeedInsights />
    </LanguageProvider>
  </StrictMode>,
);
